import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useMatch } from 'react-router'
import { FormGroup, FormControl, FormLabel, Button } from 'react-bootstrap'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import { sendPushNotification, getIconFromMessageType } from '@severed-links/common.redherrings-reducers/notifications'
import TextareaAutosize from 'react-autosize-textarea'
import Confirm from '@severed-links/common.confirm'
import { upperCaseFirst } from 'upper-case-first'
import Modal from '@severed-links/common.modal'
import Notification from './Notification'
import * as s from './SendPushNotification.scss'

const PushPreview = ({ subject, message, messageType }) => (
    <div className={s.pushPreviewContainer}>
        <div className={s.previewLabel}>Notification preview</div>
        {message && messageType && subject ?
            <Notification notification={{ subject, message, messageType, icon: getIconFromMessageType(messageType) }} />
        : <div className={s.emptyPreview}>Add a headline and message to see the notification preview.</div>}
    </div>
)

const SendPushNotification = ({ app = null }) => {

    const dispatch = useDispatch()
    const [subject, setSubject] = useState('')
    const [message, setMessage] = useState('')
    const [messageType, setMessageType] = useState('info')
    const [showPushModal, setShowPushModal] = useState(false)
    const _match = useMatch(`/:appName`)
    const appName = app || (_match && _match.params ? upperCaseFirst((_match.params.appName || '').toLowerCase().replace('/admin', '')) : '')

    const send = () => {
        dispatch(sendPushNotification({ subject, message, messageType }, appName))
        setSubject('')
        setMessage('')
        setShowPushModal(false)
    }

    const styles = [
        { value: 'info', label: 'Info', icon: 'info-circle' },
        { value: 'success', label: 'Success', icon: 'check-circle' },
        { value: 'warning', label: 'Warning', icon: 'exclamation-triangle' },
        { value: 'danger', label: 'Urgent', icon: 'exclamation-circle' },
    ]
    return (
        <span className={s.triggerContainer}>
            <Button variant='light' title='Send push notification' aria-label='Send push notification'
                onClick={() => setShowPushModal(true)}><FontAwesomeIcon name='bolt' /></Button>
            <Modal heading={'Send push notification'}
                show={showPushModal} enforceFocus={false}
                onClose={() => setShowPushModal(false)}
                showFooter={false}>
                <div className={s.modalContainer}>
                    <div className={s.audienceCallout}>
                        <div className={s.audienceIcon}><FontAwesomeIcon name='users' /></div>
                        <div>
                            <strong>Online {appName} users</strong>
                            <span>This will be delivered immediately to everyone currently connected.</span>
                        </div>
                    </div>
                    <FormGroup className={s.formGroup}>
                        <div className={s.fieldHeading}>
                            <FormLabel>Headline</FormLabel>
                            <span>{subject.length} characters</span>
                        </div>
                        <FormControl value={subject} placeholder='Enter a short headline'
                            onChange={e => setSubject(e.target.value)} />
                    </FormGroup>
                    <FormGroup className={s.formGroup}>
                        <div className={s.fieldHeading}>
                            <FormLabel>Message</FormLabel>
                            <span>{message.length} characters</span>
                        </div>
                        <TextareaAutosize name='Description' className='form-control'
                            placeholder='Write the notification message'
                            value={message}
                            onChange={e => setMessage(e.target.value)} rows={3}
                            onResize={(e) => {}} />
                    </FormGroup>
                    <FormGroup className={s.formGroup}>
                        <FormLabel>Notification tone</FormLabel>
                        <div className={s.toneGrid}>
                        {styles.map(i =>
                            <Button key={`notification-style-${i.value}`}
                                variant={messageType === i.value ? i.value : `outline-${i.value}`}
                                aria-pressed={messageType === i.value}
                                onClick={() => setMessageType(i.value)}>
                                <FontAwesomeIcon name={i.icon} /> {i.label}
                            </Button>
                        )}
                        </div>
                    </FormGroup>
                    <PushPreview subject={subject} message={message} messageType={messageType} />
                    <div className={s.actions}>
                        <Confirm variant={messageType} onConfirm={() => send()}
                            title={'Send this notification?'} enforceFocus={false}
                            confirmText='Send notification'
                            body={<div>This will be sent immediately to all online {appName} users.<br/><br/><PushPreview subject={subject} message={message} messageType={messageType} /></div>}
                            disabled={!message || !subject || !messageType}
                            buttonIcon='bolt' buttonText='Review and send' />
                    </div>
                </div>
            </Modal>

        </span>
    )
}

export default SendPushNotification
